import { validateArguments } from '../../SignatureValidation';
export var RtrimFn;
(function (RtrimFn) {
    RtrimFn.Name = `RTRIM`;
    RtrimFn.Stage = "SCALAR";
    RtrimFn.Signature = `RTRIM(<string>)`;
    function make(callName, args, type, role) {
        return {
            name: RtrimFn.Name,
            stage: RtrimFn.Stage,
            data: { role, type },
            value(...values) {
                if (values.length !== 1) {
                    throw new Error(`RTRIM function expects 1 arguments ` +
                        `but received ${values.length}`);
                }
                const value = values[0];
                if (value == null) {
                    return null;
                }
                if (typeof value !== 'string') {
                    throw new Error(`RTRIM function expects its argument to be a (string) ` +
                        `but received (${typeof value})`);
                }
                return value.trimEnd();
            },
        };
    }
    RtrimFn.make = make;
    function validate(callNode, callName, args) {
        return validateArguments({
            arguments: ["STRING"],
            meta: {
                name: RtrimFn.Name,
                signature: RtrimFn.Signature,
                location: callNode.location,
            },
        }, args);
    }
    RtrimFn.validate = validate;
})(RtrimFn || (RtrimFn = {}));
